import { DayOfMonthSchedule } from '../schema/day-of-month-schedule.schema';
import { DayOfMonthScheduleValidator } from '../validators/index';

export const isDayOfMonthSchedule = (
  value: unknown,
): value is DayOfMonthSchedule => DayOfMonthScheduleValidator.Check(value);
